export const notificationCategories = ["general", "email", "editor", "addons"];

let notificationFields = [
  {
    id: "trigger",
    label: "Notification For",
    type: "select",
    options: [
      {
        value: "wp-signup-admin",
        label: "Sign Up - Admin",
        emailSubject: "[global_site_title]:New User Registration",
        tooltip: "Email sent to site admin when new user sign-up on site",
        defaultTemplate: "basic_wp-signup-admin",
      },
      {
        value: "wp-signup-user",
        label: "Sign Up - User",
        emailSubject: "[global_site_title]:Your username and password info",
        tooltip: "Registration confirmation email sent to the new user",
        defaultTemplate: "basic_wp-signup-user",
      },
      {
        value: "wp-lost-password-admin",
        label: "Lost Password - Admin",
        emailSubject: "[global_site_title]:Password Reset",
        tooltip: "Email sent to admin when user changes their password",
        defaultTemplate: "basic_wp-lost-password-admin",
      },
      {
        value: "wp-lost-password-user",
        label: "Lost Password - User",
        emailSubject: "[global_site_title]:Password Reset",
        tooltip:
          "Verification email sent to user when requested password change",
        defaultTemplate: "basic_wp-lost-password-user",
      },
      {
        value: "wp-password-changed-user",
        label: "Password Changed - User",
        emailSubject: "[global_site_title]:Password Changed",
        tooltip: "Confirmation email for password change to the user",
        defaultTemplate: "basic_wp-password-changed-user",
      },
      {
        value: "wp-change-user-email-user",
        label: "Change Email Address - User",
        emailSubject: "",
        tooltip:
          " Email address change verification email sent to user’s new email address",
        defaultTemplate: "basic_wp-change-user-email-user",
      },
      {
        value: "wp-changed-user-email-user",
        label: "Changed Email Address - User",
        emailSubject: "[global_site_title]:Email Changed",
        tooltip:
          " Email address changed confirmation email sent to user’s old email address",
        defaultTemplate: "basic_wp-changed-user-email-user",
      },
      {
        value: "wp-comment-in-moderation-admin",
        label: "Comment In Moderation - Admin",
        emailSubject: "[global_site_title]:Please moderate: '[post_name]'",
        tooltip: "Email sent to site admin to approve comments on posts",
        defaultTemplate: "basic_wp-comment-in-moderation-admin",
      },
      {
        value: "wp-comment-published-post-author",
        label: "Comment Published - Post Author",
        emailSubject: "",
        tooltip:
          " Email sent to post author after comment published on the post",
        defaultTemplate: "basic_wp-comment-published-post-author",
      },
      {
        value: "wp-change-site-admin-email",
        label: "Change Site Admin Email",
        emailSubject: "[global_site_title]:Email Change Request",
        tooltip:
          " Email address change verification email sent to admin’s new email address",
        defaultTemplate: "basic_wp-change-site-admin-email",
      },
      {
        value: "wp-changed-site-admin-email",
        label: "Changed Site Admin Email",
        emailSubject: "[global_site_title]:Email Changed",
        tooltip:
          "Email address changed confirmation email sent to admin’s old email address",
        defaultTemplate: "basic_wp-changed-site-admin-email",
      },
      {
        value: "wp-request-personal-data-user",
        label: "Request Personal Data - user",
        emailSubject: "",
        tooltip:
          "Email sent to user for confirmation of request to export personal data",
        defaultTemplate: "basic_wp-request-personal-data-user",
      },
      {
        value: "wp-confirmed-personal-data-request-admin",
        label: "Confirmed Personal Data - admin",
        emailSubject: "",
        tooltip:
          "Confirmation email sent to site admin for user’s export personal data request",
        defaultTemplate: "basic_wp-confirmed-personal-data-request-admin",
      },
      {
        value: "wp-download-personal-data-user",
        label: "Download Personal Data - user",
        emailSubject: "",
        tooltip: " Email sent to user to download personal data",
        defaultTemplate: "basic_wp-download-personal-data-user",
      },
      {
        value: "wp-erased-personal-data-user",
        label: "Erased Personal Data - user",
        emailSubject: "",
        tooltip: "Email sent to user after data being erased from site",
        defaultTemplate: "basic_wp-erased-personal-data-user",
      },
    ],

    order: 1,
    default: { value: false, label: "Select A Trigger" },
    conditional: [
      {
        id: "identifier",
        operator: "is",
        value: "",
      },
    ],
    category: "general",
    supportsMergeTags: false,
    confirmationMessage:
      "This will remove all the template modifications you have done.",
    param: "",
  },
  {
    id: "emailSubject",
    label: "Email Subject",
    type: "text",
    order: 2,
    default: "Email Subject",
    conditional: [
      {
        id: "trigger",
        operator: "not",
        value: false,
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-change-site-admin-email",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-change-user-email-user",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-lost-password-user",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-comment-published-post-author",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-request-personal-data-user",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-confirmed-personal-data-request-admin",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-download-personal-data-user",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-erased-personal-data-user",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-gravity-form",
      },
      {
        id: "identifier",
        operator: "is",
        value: "",
      },
    ],
    category: "email",
    supportsMergeTags: true,
    confirmationMessage: "",
    param: "",
    attributes: {
      placeholder: "Enter Email Subject Here",
    },
  },
  // {
  // 	id: 'to',
  // 	label: 'Send To',
  // 	type: 'select',
  // 	options: [
  // 		{ value: 'sushilsaini90@gmail.com', label: 'Sushil Gmail' },
  // 		{ value: 'sushilsaini90@yopmail.com', label: 'Sushil Yopmail' }
  // 	],
  // 	class: '',
  // 	order: 20,
  // 	default: 'wpsignup',
  // 	conditional: [],
  // 	category: 'email'
  // },
  {
    id: "additonalEmailFields",
    label: "Additional Email Fields",
    type: "checkbox",
    val: false,
    order: 10,
    conditional: [
      {
        id: "trigger",
        operator: "not",
        value: false,
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-change-site-admin-email",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-change-user-email-user",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-lost-password-user",
      },
      {
        id: "trigger",
        operator: "not",
        value: "wp-gravity-form",
      },
      {
        id: "identifier",
        operator: "is",
        value: "",
      },
    ],
    category: "email",
    default: false,
    supportsMergeTags: false,
    confirmationMessage: "",
    param: "",
    attributes: {
      placeholder: "",
    },
  },
  {
    id: "fromName",
    label: "From Name",
    type: "text",
    order: 15,
    default: "",
    conditional: [
      {
        id: "additonalEmailFields",
        operator: "is",
        value: true,
      },
    ],
    category: "email",
    supportsMergeTags: true,
    confirmationMessage: "",
    param: "",
    attributes: {
      placeholder: "",
    },
  },

  {
    id: "fromEmail",
    label: "From Email",
    type: "text",

    order: 20,
    default: "",
    conditional: [
      {
        id: "additonalEmailFields",
        operator: "is",
        value: true,
      },
    ],
    category: "email",
    supportsMergeTags: false,
    confirmationMessage: "",
    param: "",
    attributes: {
      placeholder: "Enter From Email here",
    },
  },
  {
    id: "cc",
    label: "CC",
    type: "text",
    order: 25,
    default: "",
    conditional: [
      {
        id: "additonalEmailFields",
        operator: "is",
        value: true,
      },
    ],
    category: "email",
    supportsMergeTags: false,
    confirmationMessage: "",
    param: "",
    attributes: {
      placeholder: "Enter CC Here",
    },
  },
  {
    id: "bcc",
    label: "BCC",
    type: "text",
    order: 30,
    default: "",
    conditional: [
      {
        id: "additonalEmailFields",
        operator: "is",
        value: true,
      },
    ],
    category: "email",
    supportsMergeTags: false,
    confirmationMessage: "",
    param: "",
    attributes: {
      placeholder: "Enter BCC Here",
    },
  },
  {
    id: "emailBody",
    label: "Email Body",
    type: "hidden",
    order: 35,
    default: "",
    conditional: [],
    category: "email",
    supportsMergeTags: false,
    confirmationMessage: "",
    param: "",
    attributes: {
      placeholder: "Email Body",
    },
  },
  {
    id: "template",
    label: "Template",
    type: "hidden",
    order: 40,
    default: "",
    placeholder: "Email Body",
    conditional: [],
    category: "general",
    supportsMergeTags: false,
    confirmationMessage: "",
    param: "",
    attributes: {
      placeholder: "Email Body",
    },
  },
  {
    id: "identifier",
    label: "Identifier",
    type: "hidden",
    order: 4,
    default: "",
    conditional: [],
    category: "general",
    supportsMergeTags: false,
    confirmationMessage: "",
    param: "identifier",
    attributes: {
      placeholder: "Query String",
      readOnly: true,
    },
  },
];

if (!!window.wp) {
  notificationFields = window.wp.hooks.applyFilters(
    "wpmNotificationAllFields",
    notificationFields
  );
}

export { notificationFields };
